<template>
  <common-dialog
    :dialogVisible="dialogVisible"
    title="Notice"
    content="You can add more people to your fleet. Please finish setting up your account to unlock these features and invite people to your fleet."
    confirmContent="Yes"
    typeColor="#4066d4"
    @confirm="handleConfirm"
    @cancel="cancel"
  >
  </common-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      required: false,
      default: false,
    },
  },
  name: "commonDiamondPrompt",
  methods: {
    handleConfirm() {
      this.$emit('cancel')
      this.$router.push(`/self-order/index?redirect=${this.$route.path}`)
    },
    cancel() {
      this.$emit('cancel')
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped></style>
